export default __webpack_public_path__ + "static/media/PRA_Walk_Loop 1.9b837e10.wav";